import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mainColor:'#091C2B',
    textEvidenceColor:'#2962FF',
    figureEvidenceColor:'#C51162',
    experimentEvidenceColor:'#4DB6AC',
    cohortEvidenceColor:'#F57C00',
    currtab: 0,
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
})
